import i18n from '../../lang'

const validatePassword = (rule, value, callback) => {
  if (!value) {
    callback(new Error(i18n.t('rules.warning_empty_passwd')))
  } else if (value.length < 6) {
    callback(new Error(i18n.t('rules.warning_low_passwd')))
  } else {
    callback()
  }
}

const validateUsername = (rule, value, callback) => {
  if (!value) {
    callback(new Error(i18n.t('rules.email_empty')))
  } else {
    callback()
  }
}

const validateCode = (rule, value, callback) => {
  if (!value) {
    callback(new Error(i18n.t('rules.validate_code_empty')))
  } else {
    callback()
  }
}

const validatePasswordTest = (rule, value, callback) => {
  if (!value) {
    callback(new Error(i18n.t('rules.warning_empty_passwd')))
  } else if (value.length > 30) {
    callback(new Error(i18n.t('rules.warning_max_passwd')))
  } else if (/[\u4e00-\u9fa5]/.test(value)) {
    callback(new Error(i18n.t('rules.error_password_message')))
  } else {
    callback()
  }
}

const validateVehiclesName = (rule, value, callback) => {
  if (!value) {
    callback(new Error(i18n.t('rules.no_empty')))
  } else if (value.length > 20) {
    callback(new Error(i18n.t('rules.vehicle_name_max_20')))
  } else {
    callback()
  }
}
const validateVehiclesFleetName = (rule, value, callback) => {
  if (!value) {
    callback(new Error(i18n.t('rules.no_empty')))
  } else if (value.length > 30) {
    callback(new Error(i18n.t('rules.vehicle_name_max_30')))
  } else {
    callback()
  }
}

const validateStatus = (rule, value, callback) => {
  if (value < 0) {
    callback(new Error(i18n.t('rules.depot.depot_status_empty')))
  } else {
    callback()
  }
}

export {
  validatePassword,
  validateUsername,
  validateCode,
  validatePasswordTest,
  validateVehiclesName,
  validateVehiclesFleetName,
  validateStatus
}
